module.exports = __webpack_public_path__ + "media/src/application/media/rooms/library1-27a7ed73d3cde8a809d77adaa0225101.jpg";